import React, { Dispatch, SetStateAction } from 'react';

import { Alert, Box, CircularProgress, Stack } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import { Centered } from 'components/grid';
import { ContentModal } from 'components/modal';
import { SubTitle } from 'components/text';
import { RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';

interface QuebrasErrosModal {
    open: number | boolean;
    setOpen: Dispatch<SetStateAction<number | boolean>>;
}
interface QuebrasErrosProps {
    idConfigPedidoQuebraImportacaoValidacao: number;
    dsConfigPedidoQuebraImportacaoValidacao: string;
    dhInclusao: string;
}

export function QuebrasErrosModal({ open, setOpen }: QuebrasErrosModal) {
    const RequestListagem = useRequestListagem();

    const requestOptions: RequestOptionsType = {
        url: `/gestao/configpedidoquebraimportacaovalidacao/importacao/${open}`,
    };

    const { isLoading, fetchStatus, data } = useQuery(
        [requestOptions],
        () => {
            const request: Promise<QuebrasErrosProps[]> = RequestListagem(requestOptions).then((res) => res.data);

            return request;
        },
        {
            enabled: Boolean(open),
        },
    );

    return (
        <ContentModal open={Boolean(open)} setOpen={setOpen} sx={{ borderRadius: 2, width: { xs: '80%', sm: 'auto' } }} closeButton>
            <Box sx={{ display: 'flex', flexDirection: 'column', p: 1 }}>
                <SubTitle label="Erros" />

                {isLoading && fetchStatus === 'fetching' && (
                    <Centered>
                        <CircularProgress sx={{ my: 2 }} />
                    </Centered>
                )}

                <Stack spacing={2}>
                    {data &&
                        data.map((item) => {
                            return (
                                <Alert key={item.idConfigPedidoQuebraImportacaoValidacao} variant="outlined" severity="error">
                                    {item.dsConfigPedidoQuebraImportacaoValidacao}
                                </Alert>
                            );
                        })}
                </Stack>
            </Box>
        </ContentModal>
    );
}
